import { z } from "zod"
import { notificationSchema } from "./notification"

export enum UserChannelMessageType {
    Notification = "notification",
}

const notificationMessageSchema = z.object({
    type: z.literal(UserChannelMessageType.Notification),
    notification: notificationSchema,
})

export const userChannelMessageSchema = z.discriminatedUnion("type", [notificationMessageSchema])

export type UserChannelMessage = z.infer<typeof userChannelMessageSchema>

export const userChannelKey = (userId: string) => `user:${userId}`

export const parseUserChannelMessage = (raw: unknown): UserChannelMessage =>
    userChannelMessageSchema.parse(raw)
